module.exports = __webpack_public_path__ + "static/GT-Super-Display-Medium-e62421038ce4cb68caded8f6e6654101.woff";